import DocumentComponent from '#app/routes/_app+/documents+/$type.tsx'

export { loader } from '#app/routes/_app+/documents+/__mdx.server.tsx'
export default DocumentComponent
